import React, { useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon, FileWarningIcon } from 'lucide-react';
export function PraticheIncagliate() {
  const [searchTerm, setSearchTerm] = useState('');
  // Dati fittizi per la tabella
  const praticheIncagliate = [{
    id: '1',
    nomePratica: 'Recupero credito TechSolutions',
    dataInserimento: '15/03/2023',
    clienteNome: 'TechSolutions Spa',
    clientePiva: '98765432101',
    motivoIncaglio: 'Cliente non ha finalizzato la procedura',
    giorniIncaglio: 67,
    importo: 12000,
    stato: 'In attesa cliente'
  }, {
    id: '2',
    nomePratica: 'Piano rateizzazione Industria Meccanica',
    dataInserimento: '22/03/2023',
    clienteNome: 'Industria Meccanica Srl',
    clientePiva: '45678912301',
    motivoIncaglio: 'Mancano documenti contrattuali',
    giorniIncaglio: 60,
    importo: 8750,
    stato: 'Documenti mancanti'
  }, {
    id: '3',
    nomePratica: 'Decreto ingiuntivo Alimentari Freschi',
    dataInserimento: '05/04/2023',
    clienteNome: 'Alimentari Freschi Spa',
    clientePiva: '56789012341',
    motivoIncaglio: 'Mancano aggiornamenti dal legale',
    giorniIncaglio: 46,
    importo: 5000,
    stato: 'In attesa legale'
  }, {
    id: '4',
    nomePratica: 'Recupero Retail Fashion',
    dataInserimento: '12/04/2023',
    clienteNome: 'Retail Fashion Srl',
    clientePiva: '34567890121',
    motivoIncaglio: 'Cliente non risponde alle comunicazioni',
    giorniIncaglio: 39,
    importo: 15200,
    stato: 'Nessuna risposta'
  }, {
    id: '5',
    nomePratica: 'Piano rateizzazione Logistica Express',
    dataInserimento: '20/04/2023',
    clienteNome: 'Logistica Express Srl',
    clientePiva: '78901234561',
    motivoIncaglio: 'Mancano dati bancari',
    giorniIncaglio: 31,
    importo: 12300,
    stato: 'Dati mancanti'
  }, {
    id: '6',
    nomePratica: 'Cessione credito Edilizia Moderna',
    dataInserimento: '28/04/2023',
    clienteNome: 'Edilizia Moderna Srl',
    clientePiva: '23456789011',
    motivoIncaglio: 'Documentazione incompleta',
    giorniIncaglio: 23,
    importo: 6500,
    stato: 'Documenti incompleti'
  }, {
    id: '7',
    nomePratica: 'Sollecito pagamento GreenEnergy',
    dataInserimento: '05/05/2023',
    clienteNome: 'GreenEnergy Spa',
    clientePiva: '89012345671',
    motivoIncaglio: 'In attesa di conferma invio PEC',
    giorniIncaglio: 16,
    importo: 4800,
    stato: 'In attesa conferma'
  }];
  // Filtraggio per termine di ricerca
  const filteredPratiche = praticheIncagliate.filter(pratica => pratica.nomePratica.toLowerCase().includes(searchTerm.toLowerCase()) || pratica.clienteNome.toLowerCase().includes(searchTerm.toLowerCase()) || pratica.clientePiva.includes(searchTerm) || pratica.motivoIncaglio.toLowerCase().includes(searchTerm.toLowerCase()));
  // Funzione per determinare la classe di colore in base ai giorni di incaglio
  const getColorByDays = (days: number) => {
    if (days >= 60) return 'text-red-600';
    if (days >= 30) return 'text-amber-600';
    return 'text-gray-500';
  };
  return <div className="space-y-6 pb-16" data-id="element-1627">
      <div data-id="element-1628">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1629">
          Pratiche Incagliate
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1630">
          Pratiche che sono ferme e necessitano di intervento
        </p>
      </div>
      <div className="bg-white shadow rounded-lg" data-id="element-1631">
        <div className="px-4 py-5 sm:p-6" data-id="element-1632">
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 sm:justify-between mb-4" data-id="element-1633">
            <div className="relative flex-1 max-w-md" data-id="element-1634">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1635">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-1636" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-[#1A3E5C] focus:border-[#1A3E5C] sm:text-sm" placeholder="Cerca per nome pratica, cliente, motivo..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1637" />
            </div>
            <div className="flex space-x-2" data-id="element-1638">
              <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-1639">
                <FilterIcon className="h-4 w-4 mr-2" data-id="element-1640" />
                Filtri
              </button>
              <button className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C]" data-id="element-1641">
                <DownloadIcon className="h-4 w-4 mr-2" data-id="element-1642" />
                Esporta
              </button>
            </div>
          </div>
          {filteredPratiche.length === 0 ? <div className="text-center py-10" data-id="element-1643">
              <FileWarningIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1644" />
              <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-1645">
                Nessuna pratica incagliata trovata
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-1646">
                Non ci sono pratiche che corrispondono ai criteri di ricerca.
              </p>
            </div> : <div className="overflow-x-auto" data-id="element-1647">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1648">
                <thead className="bg-gray-50" data-id="element-1649">
                  <tr data-id="element-1650">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1651">
                      Nome Pratica
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1652">
                      Data Inserimento
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1653">
                      Cliente
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1654">
                      Motivo Incaglio
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1655">
                      Giorni Incaglio
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1656">
                      Importo
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1657">
                      Stato
                    </th>
                    <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1658">
                      Azioni
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1659">
                  {filteredPratiche.map(pratica => <tr key={pratica.id} className="hover:bg-gray-50" data-id="element-1660">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1661">
                        <div className="text-sm font-medium text-gray-900" data-id="element-1662">
                          {pratica.nomePratica}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1663">
                        <div className="text-sm text-gray-500" data-id="element-1664">
                          {pratica.dataInserimento}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1665">
                        <div className="text-sm text-gray-900" data-id="element-1666">
                          {pratica.clienteNome}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-1667">
                          {pratica.clientePiva}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1668">
                        <div className="text-sm text-gray-500" data-id="element-1669">
                          {pratica.motivoIncaglio}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1670">
                        <div className={`text-sm font-medium ${getColorByDays(pratica.giorniIncaglio)}`} data-id="element-1671">
                          {pratica.giorniIncaglio} giorni
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1672">
                        <div className="text-sm font-medium text-gray-900" data-id="element-1673">
                          {new Intl.NumberFormat('it-IT', {
                      style: 'currency',
                      currency: 'EUR'
                    }).format(pratica.importo)}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-1674">
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800" data-id="element-1675">
                          {pratica.stato}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1676">
                        <a href="#" className="text-[#1A3E5C] hover:text-[#15324a] mr-4" data-id="element-1677">
                          Sblocca
                        </a>
                        <a href="#" className="text-[#1A3E5C] hover:text-[#15324a]" data-id="element-1678">
                          Dettagli
                        </a>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
          <div className="mt-4 flex items-center justify-between" data-id="element-1679">
            <div data-id="element-1680">
              <p className="text-sm text-gray-700" data-id="element-1681">
                Visualizzazione{' '}
                <span className="font-medium" data-id="element-1682">{filteredPratiche.length}</span>{' '}
                di{' '}
                <span className="font-medium" data-id="element-1683">{praticheIncagliate.length}</span>{' '}
                pratiche incagliate
              </p>
            </div>
            <div data-id="element-1684">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-1685">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1686">
                  <span className="sr-only" data-id="element-1687">Precedente</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1688">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-1689" />
                  </svg>
                </a>
                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1690">
                  1
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1691">
                  <span className="sr-only" data-id="element-1692">Successivo</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-1693">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-1694" />
                  </svg>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
}